import { render, staticRenderFns } from "./data-empty-guide.vue?vue&type=template&id=f58f4e5c&scoped=true&"
import script from "./data-empty-guide.vue?vue&type=script&lang=ts&"
export * from "./data-empty-guide.vue?vue&type=script&lang=ts&"
import style0 from "./data-empty-guide.vue?vue&type=style&index=0&id=f58f4e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58f4e5c",
  null
  
)

export default component.exports